import CustomPage from "components/CustomPage";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import GroupData from "./components/groupData";
import Header from "./Header";
import { useDispatch } from "react-redux";
import { apiUrl } from "config/settings";
import http from 'http'
import { setShowLoading } from "store/sysSlice";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import NoData from "components/NoData";
import { useParams } from "react-router-dom";
import { ROLES_ID } from "config/roles";
import { sortArray } from "config/functions";
import NullCheck from "components/NullCheck";
import RelayGroup from "./commands/RelayGroup";
import { MC_WIHT_RELAY } from "config/const";
import { monitoringControllers } from "containers/microControllers/b22/monitoring";

const ControlAndMonitoring = () => {
  const { bt } = useBizTypeTranslation();
  const theme = useTheme()
  const dispatch = useDispatch()
  const { type, value } = useParams();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const list = useSelector((state) => state?.mc.mcList);
  const user = useSelector((state) => state.userSettings?.user);
  const [mcList, setMcList] = useState([])
  const [selectedMcStatus, setSelectedMcStatus] = useState(0)
  const [selectedArea, setSelectedArea] = useState('all')
  const [areas, setAreas] = useState([])
  const [deviceList, setDeviceList] = useState([])
  const [selectedDevice, setSelectedDevice] = useState('all')
  const [textSearch, setTextSearch] = useState("")
  const [openRelayGroup, setOpenRelayGroup] = useState(false)

  const mcStatus = [
    { id: 0, title: 'ALL' },
    { id: 1, title: 'ON_MC' },
    { id: 2, title: 'OFF_MC' },
    { id: 3, title: 'FAULTS' },
    { id: 4, title: 'LOW_EFFECTIVE' },
  ]

  useEffect(() => {
    if (type === "status")
      setSelectedMcStatus(parseInt(value))
    else if (type === "device")
      setSelectedDevice(value)
    else if (type === "area")
      setSelectedArea(value)
    else
      setSelectedMcStatus(0)
  }, [type]);

  useEffect(() => {
    getAreas()
  }, [])

  useEffect(() => {
    if (list?.length > 0) {
      let newDeviceList = []
      monitoringControllers(list).forEach(i => {
        if (!newDeviceList.includes(i.deviceType))
          newDeviceList.push(i.deviceType)
      })
      setDeviceList(newDeviceList)
    }
  }, [list]);

  useEffect(() => {
    filterList(selectedMcStatus, selectedArea, selectedDevice, textSearch)
  }, [list, selectedArea, selectedMcStatus, selectedDevice, textSearch])

  const getAreas = () => {
    dispatch(setShowLoading(true));
    http.get(`${apiUrl}/area`).then((res) => {
      setAreas(res?.data?.data);
      dispatch(setShowLoading(false));
    });
  };

  const filterList = (status, areaId, deviceId, textSearch) => {
    let newList = [...list]

    if ((user?.userRole === ROLES_ID.DEPARTMENT_MANAGER ||
      user?.userRole === ROLES_ID.EMPLOYEE) &&
      user?.department?.mcList?.length > 0) {
      newList = newList?.filter(mc => user?.department?.mcList?.some(deptMc => deptMc === mc.id))
    }

    newList = monitoringControllers(newList)

    if (textSearch !== "") {
      newList = newList?.filter((mc) =>
        mc?.name?.toString().includes(textSearch) ||
        bt(mc?.deviceType).includes(textSearch) ||
        mc?.area?.name?.toString().includes(textSearch)
      );
    }

    if (areaId !== 'all')
      newList = newList.filter(mc => mc?.area?.id === areaId)

    if (deviceId !== 'all')
      newList = newList.filter(mc => mc?.deviceType === deviceId)

    if (status === mcStatus[0]?.id)
      newList = newList
    else if (status === mcStatus[1]?.id)
      newList = newList.filter(mc => mc?.turnOnDate && mc?.isConnected)
    else if (status === mcStatus[2]?.id)
      newList = newList.filter(mc => !mc?.turnOnDate || !mc?.isConnected)
    else if (status === mcStatus[3]?.id)
      newList = newList.filter(mc => mc?.fault || !mc?.isConnected)
    else if (status === mcStatus[4]?.id)
      newList = newList.filter(mc => Number.isFinite(mc?.effective) && mc?.effective <= 60)


    newList = sortArray(newList, "seq")


    setMcList(newList)
  }

  return (
    <CustomPage
      hidePadding
      hideTitle
      heightHeader={{ xs: 100, md: 40 }}
      header={<Header
        isMobile={isMobile}
        areas={areas}
        setOpenRelayGroup={setOpenRelayGroup}
        setTextSearch={setTextSearch}
        textSearch={textSearch}
        mcStatus={mcStatus}
        deviceList={deviceList}
        selectedMcStatus={selectedMcStatus}
        selectedArea={selectedArea}
        selectedDevice={selectedDevice}
        setSelectedMcStatus={(st) => setSelectedMcStatus(st)}
        setSelectedArea={(area) => setSelectedArea(area)}
        setSelectedDevice={(device) => setSelectedDevice(device)}
      />
      }
    >
      {mcList.length > 0
        ? <Stack overflow='hidden' >
          <GroupData isMobile={isMobile} list={mcList} />
        </Stack>
        : <NoData />
      }

      <NullCheck valueForCheck={openRelayGroup}>
        <RelayGroup
          mcList={mcList?.filter(mc => MC_WIHT_RELAY?.includes(mc?.softwareType))}
          open={openRelayGroup}
          selectedArea={selectedArea}
          areas={areas}
          setOpen={setOpenRelayGroup}
        />
      </NullCheck>

    </CustomPage>
  );
};
export default ControlAndMonitoring;
